import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ContentService} from "../../_services/content.service";
import {AuthService} from "../../_services/auth.service";
import {SnackbarService} from "../../_services/snackbar.service";
import {User} from "../../_types/user";
import {Faq} from "../../_types/content";

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrl: './faqs.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaqsComponent implements OnInit {
    user!: User;
    faqs: Faq[] = []
    loading: boolean = true;
    loadFailed: boolean = false;

    constructor(protected authService: AuthService,
                private contentService: ContentService,
                private snackbarService: SnackbarService) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.authService.refreshUser();
    }

    ngOnInit(): void {
        this.authService.getDynamicSettings().then((r): void => {
            this.contentService.faqs({
                training_center_type: this.user?.role?.role_type,
                role: this.user?.role?.name,
                is_raa_training: r.is_raa
            }).subscribe({
                next: r => {
                    this.faqs = r;
                    this.loading = false;
                }, error: error => {
                    this.loadFailed = true;
                    this.loading = false;
                    console.error(error)
                    this.snackbarService.openSnackBar('Sorry, we could not load FAQs. Please try again later.', 'error')
                }
            });
        });
    }

    link(url: string, download: boolean, name?: string): void {
        this.authService.refreshUser();
        if (download) {
            let downloadName: string = url
            if (name) {
                downloadName = name?.replace(/ /g, "_");
            }
            fetch(url)
                // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
                .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
                .then(blob => {
                    const url: string = window.URL.createObjectURL(blob);
                    const a: HTMLAnchorElement = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    // the filename you want
                    a.download = downloadName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(() => function (): void {
                    console.error('catch error')
                    window.open(url, '_blank')?.focus();
                });
        } else {
            window.open(url, '_blank')?.focus();
        }
    }


}
